import { Injectable } from "@angular/core"
import {  Resolve} from "@angular/router"
import {catchError, of} from "rxjs"
import { AuthenticationService } from "../authentication.service";
@Injectable()

export class RouteResolver implements Resolve<any>{

    constructor(private auth:AuthenticationService ){

    }
    resolve() {
        let obj={}
        let a=this.auth.getErpUser(obj)
        console.log(a,"i am reso")
        return a
        // .pipe(
        //     catchError(error =>{
        //         return of({error:"API failed"})
        //     })
        // );
    }
}